import { Box, Grid, GridSize, Typography } from "@mui/material";
import { ITest, LabelPosition, RequiredAsterisk } from "@websential/cosmic-v20";
import React, { FC, ReactElement } from "react";

import InputLabel from "@mui/material/InputLabel";
import { useTheme } from "@mui/material/styles";

export interface IFieldLayout extends ITest {
  /**
   * The label content.
   */
  label?: React.ReactNode;
  /**
   * If true, the '*' sign is displayed as required.
   */
  isRequired?: boolean;
  /**
   * Set the position of label on the top or left of the input
   */
  labelPosition?: LabelPosition;
  /**
   * Will render given field of form
   */
  children: ReactElement | ReactElement[];
  /**
   * Defines the number of grids the label is going to use.
   */
  labelColumns?: GridSize;
  /**
   * Defines the number of grids the field is going to use.
   */
  fieldColumns?: GridSize;
  /**
   * Defines the number of spacing unit of top padding for field
   */
  fieldTopPadding?: number;
}

export const FieldLayout: FC<IFieldLayout> = ({
  label,
  isRequired,
  labelPosition,
  children,
  testId,
  labelColumns = 3,
  fieldColumns = 9,
  fieldTopPadding = 0
}: IFieldLayout) => {
  const theme = useTheme();

  const renderLabel = () => {
    return (
      <InputLabel>
        <Typography variant="subtitle2" sx={{whiteSpace: "normal"}} component="span">
          {label} {isRequired && <RequiredAsterisk />}
        </Typography>
      </InputLabel>
    );
  };

  return (
    <Grid container>
      <Grid
        // item
        data-testid={testId + "-label"}
        sx={{
          // marginTop:
          //   labelPosition === LabelPosition.Left
          //     ? theme.spacing(1)
          //     : theme.spacing(0),
          marginTop:theme.spacing(0),
          paddingTop:
            labelPosition === LabelPosition.Left
              ? theme.spacing(1)
              : theme.spacing(0),
        }}
        size={{ xs: labelPosition === LabelPosition.Left ? labelColumns : 12,sm:labelPosition === LabelPosition.Left ? labelColumns : 12, md: labelPosition === LabelPosition.Left ? labelColumns : 12 }}
        >
        {renderLabel()}
      </Grid>
      <Grid
        data-testid={testId + "-child"}
        // md={}
        // sm={}
        // xs={}
        size={{ xs: labelPosition === LabelPosition.Left ? fieldColumns : 12,sm:labelPosition === LabelPosition.Left ? fieldColumns : 12, md: labelPosition === LabelPosition.Left ? fieldColumns : 12 }}
      >
        <Box
          sx={{
            paddingTop:
              labelPosition === LabelPosition.Left
                ? theme.spacing(fieldTopPadding)
                : theme.spacing(fieldTopPadding),
          }}
        >
          {children}
        </Box>
      </Grid>
    </Grid>
  );
};
